module.exports = __webpack_public_path__ + "img/soccer.d3e30f2a.jpg";